import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-separator',
  template: '',
  styleUrls: ['./separator.component.scss'],
})
export class SeparatorComponent {}
